import { Badge, Box, Tooltip } from "@mui/material";
import HomeIcon from '@mui/icons-material/HomeWork';
import React, { useRef, useState } from "react";
import Grid from "@mui/material/Grid2";
import useDebugInformation from "../../../../../../../../../hooks/useDebugInformation";
import { ui } from "../../../../../../../../../interfaces/interfaces";
import { useAddressString } from "./hooks";
import { isDev } from "@utils/general";
import test from "@utils/testing";
import { useAppSelector } from "@store/hooks";

type Props = {
}

const AreaNotification: React.FC<Props> = () => {
    const badgeRef = useRef(null)
    const propertyAddressesLength = useAppSelector(({ temp }) => temp.PropertyAddressAddressesLength)
    const problemActiveSearch = useAppSelector(({ temp }) => temp.ProblemAddressActiveSearch)
    const addressString = useAddressString()
    const postcode = useAppSelector(({ state }) => state.JobPostcode)
    const [problemPostcode, setProblemPostcode] = useState<string>("")

    // useEffect to set problemPostcode only if problemActiveSearch is true
    React.useEffect(() => {
        if (problemActiveSearch) {
            setProblemPostcode(postcode)
        }
    }
        , [postcode, problemActiveSearch, propertyAddressesLength]);

    const showModal = React.useCallback(() => propertyAddressesLength > 0 && (ui.PropertyAddressModalOpen = true), [propertyAddressesLength])

    useDebugInformation("AreaNotification", { badgeRef, propertyAddressesLength, problemActiveSearch, addressString, problemPostcode })
    return (
        (<Grid
            size={{
                xs: 12,
                sm: 6
            }}>
            <Tooltip title={propertyAddressesLength > 0 ? "Click to select different address" : "No addresses found!"} sx={{ maxWidth: "none" }}>
                <Box className={`addresses ${propertyAddressesLength === 0 ? "no-addresses" : ""}`} data-addresses={propertyAddressesLength} onClick={showModal} onContextMenu={(e) => { e.preventDefault(); isDev() && (ui.ProblemInputPostcode = test.postcode()) }}>
                    <Badge ref={badgeRef} badgeContent={propertyAddressesLength} color="primary" >
                        <HomeIcon />
                    </Badge>
                    <div style={{
                        position: "relative", left: 20, textOverflow: "ellipsis",
                        width: "fit-content", whiteSpace: "nowrap",
                        overflow: "hidden", color: addressString ? "green" : "red"
                    }}>{addressString ? addressString : problemActiveSearch ? (problemPostcode + " No addresses found!!") : "Invalid Postcode"}</div>
                </Box >
            </Tooltip>
        </Grid >)
    );
}

export default React.memo(AreaNotification)